var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextZeigen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Text-Zeigen__Icn/40px/Text-Zeigen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6970443,26 L23.6970443,25.6725664 L23.2906404,25.6725664 C22.941434,25.6725664 22.6659825,25.6150442 22.4642857,25.5 C22.2625889,25.3849558 22.127121,25.2507375 22.0578818,25.0973451 C21.9886426,24.9439528 21.954023,24.560472 21.954023,23.9469027 L21.954023,23.9469027 L21.954023,14.6902655 L22.8661741,14.6902655 C23.43815,14.6902655 23.8385331,14.7433628 24.0673235,14.8495575 C24.4767378,15.0442478 24.7988506,15.3053097 25.0336617,15.6327434 C25.2684729,15.960177 25.4822113,16.4985251 25.6748768,17.2477876 L25.6748768,17.2477876 L26,17.2477876 L26,14 L15,14 L15,17.2477876 L15.3431856,17.2477876 C15.4816639,16.3628319 15.8128079,15.6814159 16.3366174,15.2035398 C16.709907,14.8613569 17.3089765,14.6902655 18.1338259,14.6902655 L18.1338259,14.6902655 L19.0188834,14.6902655 L19.0188834,23.9469027 C19.0188834,24.5486726 18.985769,24.920354 18.9195402,25.0619469 C18.8292282,25.2625369 18.7058019,25.4041298 18.5492611,25.4867257 C18.3325123,25.6106195 18.0465244,25.6725664 17.6912972,25.6725664 L17.6912972,25.6725664 L17.2848933,25.6725664 L17.2848933,26 L23.6970443,26 Z",
    id: ".._.._src_svg_Icn_40px_Text-Zeigen__T"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextZeigen);
export default __webpack_public_path__ + "static/media/Text-Zeigen.c2a21cfedae03ed1ac790cead94d4345.svg";
export { ForwardRef as ReactComponent };